import axios from "axios";

export default {
    name: "pembayaranPiutang",
    state: {
        data: Array,
        editdata: Array,
    },
    getters: {
        getListPembayaranPiutang: state => {
            return state.list
        },
        getManifestpembayaranPiutang: state => {
            return state.data
        },
        getRevisipembayaranPiutang: state => {
            return state.editdata
        },
    },
    mutations: {
        setListPembayaranPiutang: (state, payload) => {
            state.data = payload
        },
        setmanifest: (state, payload) => {
            state.data = payload
        },
        setrevisi: (state, payload) => {
            state.editdata = payload
        },
    },
    actions: {
        getListPembayaranPiutang(store, { auth, id_manifest }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        id_manifest: id_manifest
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setmanifest", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getManifestpembayaranPiutang(store, { auth, id_manifest }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        id_manifest: id_manifest
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setmanifest", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRevisipembayaranPiutang(store, { auth, id_manifest }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang/revisi",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        id_manifest: id_manifest
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setrevisi", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitpembayaranPiutang(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitRevisipembayaranPiutang(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang/revisi",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitpaypembayaranPiutang(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Pembayaran_piutang/payment",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        genPaypembayaranPiutang(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "pembayaran_piutang/generate_detail_payment",
                    params: {tlc : payload},
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "application/json",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
